module.exports = "<span ng-class=\"{\n    'h-red-text': (percentage < 0),\n    'h-green-text': (percentage >= 0)\n  }\" ng-bind=percentage|holdingFormatPercentage> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/overview/directives/percentage-change/percentage-change.html
// module id = 759
// module chunks = 0